import { memo } from "react";

const DeliveriesMarker = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="7" width="10" height="10" rx="5" fill="#666666" />
    </svg>
  );
};

export default memo(DeliveriesMarker);
